import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from './MetaPixel';
export const CHECKOUT_URL = 'https://mathe-bereit.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Hol dir das MATHE BEREIT™ Paket',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} onClick={() => {
    if (!isInternal) trackPixelEvent('InitiateCheckout', {
      value: 17.99,
      currency: 'EUR'
    });
  }} className={`group inline-flex items-center justify-center gap-3 rounded-2xl border-b-4 border-sun-dark bg-sun px-7 py-5 text-center font-display text-sm font-extrabold uppercase leading-tight tracking-[0.04em] text-navy shadow-soft transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#ffd455] active:translate-y-0 focus:outline-none focus-visible:ring-4 focus-visible:ring-sun/50 sm:px-9 sm:text-base ${className}`} data-id="element-64" data-mp="qiz9gw2qldy1">
      <span data-id="element-65" data-mp="3exu9i69b2kds">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-66" data-mp="3exb0xg5jp8cf" />
    </a>;
}